module.exports = __webpack_public_path__ + "img/06.5d9cdcd7.gif";